export default __webpack_public_path__ + "static/media/Helm of the Unholy Communion.c915a8b2.jpg";